import * as classroomScreenApi from "@/apis/classroomScreen/screens";
import { useActionCableChannel } from "@/composables/useActionCableChannel";
import { useClassroomScreenStore } from "@/stores/classroomScreen";
import type {
  ActionCableCallback,
  ActionCableUserActionData,
  ActionCableData,
} from "@/types";

export function subscribeToBoardChannel(screenId: string, userId?: string) {
  let callbacks: ActionCableCallback[] = [];
  const registerCallback = (callback: ActionCableCallback) => {
    if (!callbacks) {
      callbacks = [];
    }

    callbacks.push(callback);
  };

  const store = useClassroomScreenStore();

  async function retrieveHistory() {
    const screen = await classroomScreenApi.show(screenId);
    store.$patch({ screen: screen });
  }

  const onUpdate = (data: ActionCableData) => {
    const extendedData = data as ActionCableUserActionData;
    if (extendedData.action) {
      const action = extendedData.action;
      const payload = JSON.parse(extendedData.payload);

      // only process messages which are not published by same user
      if (userId !== extendedData.user_id) {
        store.dynamicDispatch(action, payload);

        if (callbacks && callbacks.length > 0) {
          callbacks.forEach((callback: ActionCableCallback) => {
            callback(
              extendedData.action,
              extendedData.user_id,
              extendedData.payload
            );
          });
        }
      }
    }
  };

  const actionCableSubscription = useActionCableChannel(
    "ClassroomScreen::ScreenChannel",
    { id: screenId },
    {
      onUpdate,
      retrieveHistory,
    }
  );

  return {
    unsubscribe: () => actionCableSubscription.unsubscribe(),
    actionCableSubscription,
    registerCallback,
  };
}
